import * as React from 'react';
import { IILDataSaveConnectProps } from './il-data-save-container';
import { DataSaveContainer } from '../../data-save';
import { DataLoadApi } from '../../../api';
import { IILConfig } from '../../../interfaces';
import { DATA_LOAD_TYPE } from '../../../constants';
import { getApiILConfig } from '../../../functions';

/**
 * Wrapper around "Data Save" component for Indicator-Indicator Links
 */
export class ILDataSave extends React.Component<IILDataSaveConnectProps> {
  constructor(props: IILDataSaveConnectProps) {
    super(props);
    this.onRetry = this.onRetry.bind(this);
  }

  public onRetry(): Promise<{}> {
    const config: IILConfig = getApiILConfig({
      config: this.props.config.IL,
      ui: this.props.ui,
      upload: this.props.upload
    });

    return DataLoadApi.uploadILConfig({ config, columns: this.props.config.columns }).request();
  }

  public render(): JSX.Element {
    if (!this.props.config.IL) { return null; }

    const nRows: number = this.props.config.IL.tableConfig.dataEndRow
      - this.props.config.IL.tableConfig.dataStartRow;

    return (
      <DataSaveContainer
        nRows={nRows}
        dataLoadType={DATA_LOAD_TYPE.INDICATOR_INDICATOR_LINK}
        onRetry={this.onRetry}
      />
    );
  }
}
